<template>
  <article class="card">
    <div class="card_date">{{ toLocalDate(publishIsoDate) }}</div>
    <div class="card_image">
      <a :href="link" target="_blank">
        <img :src="imgSrc" :alt="title">
      </a>
    </div>
    <h3 class="card_title">
      <a :href="link" target="_blank">
        {{ title }}
      </a>
    </h3>
    <p class="card_description" v-html="description"></p>
  </article>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'NewsCard',
  props: {
    imgSrc: {},
    title: {},
    link: {},
    description: {},
    publishIsoDate: {}
  },
  methods: {
    toLocalDate: (isoDate) => {
      if (!isoDate) return ''
      return DateTime.fromISO(isoDate).toFormat('yyyy-MM-dd')
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import '../../assets/stylesheets/mixins';

.card {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;

  @include bpOnlyPc() {
    &:not(:nth-of-type(-n+3)) {
      margin-top: 30px;
    }
  }
  @include bpOnlySp() {
    &:not(:first-child) {
      margin-top: 30px;
    }
  }

  &_image {
    display: flex;
    justify-content: center;
    align-items: center;
    background: $white;
    height: 200px;
    width: 280px;
    margin-top: 10px;
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  &_title {
    @include bpOnlyPc() {
      min-height: calc(20px * 1.2 * 2);
      margin-top: 30px;
    }
    @include bpOnlySp() {
      margin-top: 20px;
    }
    font-size: 20px;
    font-weight: 500;
    line-height: 1.4;
    text-align: left;
    color: $buildNavy;
    letter-spacing: 0.02em;
  }
  &_description {
    width: 100%;
    overflow: hidden;
    @include bpOnlyPc() {
      margin-top: 30px;
    }
    @include bpOnlySp() {
      margin-top: 16px;
    }
    font-size: 16px;
    line-height: 1.7;
    color: $buildNavy;
    letter-spacing: 0.105em;
    text-align: left;

  }
  &_description ::v-deep img {
    width: 100%;
  }
  &_date {
    width: 100%;
  }
}
</style>
